export enum CUSTOM_FIELD_FOR {
  PATIENT = 'patient',
  APPOINTMENT = 'appointment',
  REFERRAL = 'referral',
  AUTHORIZATION = 'authorization',
  TRANSACTION = 'transaction',
}
